<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_ii"></a>©2022 Jeaninne Surette Honstein and Steven A. Knowlton</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means without the prior written permission of the publisher.</p>
<p class="copy1">First edition, first printing</p>
<p class="copya">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy2">Names: Federhen, W. F. Oscar, 1846 – author. | Honstein, Jeaninne Surette, editor. | Knowlton, Steven A. (Steven Anthony), 1971 – editor.</p>
<p class="copy3">Title: Thirteen months in Dixie: or, Adventures of a Federal Prisoner in Texas, including the Red River Campaign, Imprisonment at Camp Ford, and Escape Overland to Liberated Shreveport, 1864-1865 / by W. F. Oscar Federhen; edited by Jeaninne Surette Honstein and Steven A. Knowlton.</p>
<p class="copy3">Other titles: Adventures of a Federal Prisoner in Texas</p>
<p class="copy3">Description: El Dorado Hills, CA: Savas Beatie LLC, [2022] | Includes bibliographical references and index. | Summary: “Oscar Federhen of the 13th Massachusetts Light Artillery was captured by Confederate soldiers during the Red River Campaign in the spring of 1864. Federhen was marched overland to Tyler, Texas, where he was held as a prisoner of war in Camp Ford but later escaped to Union lines. After the war, Federhen wrote a memoir of his wartime experiences. This book contains his transcribed and annotated manuscript with illustrations, including two from Federhen’s own pen.” — Provided by publisher.</p>
<p class="copy3">Identifiers: LCCN 2022007400 | ISBN 9781611215885 (hardcover) | ISBN 9781611215892 (ebook) | ISBN 9781611215892 (Mobi)</p>
<p class="copy3">Subjects: LCSH: United States–History–Civil War, 1861-1865–Personal narratives. | United States–History–Civil War, 1861-1865–Prisoners and prisons. | Camp Ford (Tex.) | Prisoner-of-war escapes–Texas–History–19th century. | Escaped prisoners of war–United States–Biography. | Soldiers–United States–Diaries. | United States. Army. Massachusetts Infantry Regiment, 13th</p>
<div class="img_containerl">
<img alt="images" src="images/copy.jpg"/>
</div>
<p class="copy4">Savas Beatie</p>
<p class="copy">989 Governor Drive, Suite 102,</p>
<p class="copy">El Dorado Hills, CA 95762</p>
<p class="copy">916-941-6896 / <span class="weblink"><a href="mailto:sales@savasbeatie.com"><span class="underline">sales@savasbeatie.com</span></a></span> / <span class="weblink"><a href="http://www.savasbeatie.com" target="_blank"><span class="underline">www.savasbeatie.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Copyright.vue?e3053d62